import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/CatShop.css';
import axios from 'axios';
import ls from 'local-storage'
import Loading from "./Loading";
import Retry from "./Retry";
import TopNav from "./TopNav";
import AppBody from "./AppBody";

class MoreStoreOfMenuItems extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            url:"",
            item_id:null,
            loading: true,
            page:1,
            shopList: [],
        };
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    componentWillMount() {
        let item_id = ls.get("item_id");
        if(item_id == null || item_id <= 0){
            this.props.history.push("/");
        }
        this.setState({item_id:item_id},()=>{this.loadMoreStores()})
    }

    componentDidMount = () => {
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );

        return (
            <AppBody loading={this.state.loading} showBotNav={true} name={"لیست فروشگاه ها"} type={" bg-white"}>
                {this.renderShops()}
            </AppBody>
        );
    }

    loadMoreStores(){
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getExtraStoresFromHomeItem+"?item_id="+this.state.item_id)
            .then(res => {
                if(res.data.code == 200){
                    console.log('Stores : ',res.data.stores.data);
                    this.setState({shopList:res.data.stores.data,loading:false});
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false});
            });
    }

    renderShops(){
        return this.state.shopList.map((data)=>{
            return (
                <div className={"catShopElm"}  onClick={()=>this.handleShop(data.id)}>
                    <div className={"catShopImgElm"}>
                        <img className={"catShopImg"} src={urls.SiteUrl+data.store_image}/>
                    </div>
                    <div className={"catShopText"}>{data.store_name}</div>
                </div>
            )
        });
    }
    handleRedirect(menu){
        switch (menu.menuen) {
            case "store":
                this.setState({redirect:true,url:"/categories"});
                break;
            case "new_products":
                this.setState({redirect:true,url:"/new_products"});
                break;
            default :
                break;
        }

    }

    handleShop(shopId){
        ls.set("store_id",shopId);
        this.props.history.push({
            pathname: '/store',
            state: {id:shopId}
        });
    }
}



export default MoreStoreOfMenuItems;
